import {HateoasResource, Resource} from '@lagoshny/ngx-hateoas-client';

@HateoasResource('searchquery')
export class SearchQuery extends Resource {
    id!: number;
    query!: string;
    type!: string;
    documentStates!: string;
}
